import { render, staticRenderFns } from "./DocHeading.vue?vue&type=template&id=394c707d&"
import script from "./DocHeading.vue?vue&type=script&lang=js&"
export * from "./DocHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports